import { curveStepAfter } from 'd3-shape';
import { Curve } from './curve';
export const HV = (options) => {
    return (P, value, coordinate, theme) => {
        return Curve(Object.assign({ curve: curveStepAfter }, options))(P, value, coordinate, theme);
    };
};
HV.props = Object.assign({}, Curve.props);
//# sourceMappingURL=hv.js.map